import {h, Fragment} from "preact"
import { useEffect, useState } from 'preact/hooks'
import { useAppState } from '@nosto/preact';

export default ({ tags1, customFields, categories, availability, product }) => {
    const [badge, setBadge] = useState("");

    const isSoldOut = availability === "OutOfStock";
    const hasPick = tags1?.some((tag) => tag.toLowerCase().includes("badge") && tag.toLowerCase().includes("pick"));
    const is25off = tags1?.some((tag) => tag.toLowerCase().includes("badge") && tag.toLowerCase().includes("25% off"));
    const isSaleOnSale = tags1?.some((tag) => tag.toLowerCase().includes("badge") && tag.toLowerCase().includes("sale on sale"))
    const isNewToSale = tags1?.some((tag) => tag.toLowerCase().includes("badge") && tag.toLowerCase().includes("new to sale"))
    const isNewArrival = tags1?.some((tag) => tag.toLowerCase().includes("badge") && tag.toLowerCase().includes("new"))

    const isLimited20 = tags1?.some((tag) => tag.toLowerCase().includes("badge") && tag.toLowerCase().includes("limited 20% off"))
    const isLimited30 = tags1?.some((tag) => tag.toLowerCase().includes("badge") && tag.toLowerCase().includes("limited 30% off"))
    const isLimited40 = tags1?.some((tag) => tag.toLowerCase().includes("badge") && tag.toLowerCase().includes("limited 40% off"))
    const isLimited50 = tags1?.some((tag) => tag.toLowerCase().includes("badge") && tag.toLowerCase().includes("limited 50% off"))
    const isLimited60 = tags1?.some((tag) => tag.toLowerCase().includes("badge") && tag.toLowerCase().includes("limited 60% off"))
    const isLimitedTime = tags1?.some((tag) => tag.toLowerCase().includes("badge") && tag.toLowerCase().includes("limited time offer"))

    const hasBadgeName = customFields?.find(k => k.key === "badge-name")?.value

    useEffect(() => {
        if (isSoldOut) {
            setBadge("out of stock")
        } else if (hasBadgeName) {
            setBadge(hasBadgeName)
        }
        
        // else if (hasPick) {
        //     tags1?.forEach((item) => {
        //         if (item.toLowerCase().includes("badge") && item.toLowerCase().includes("pick")) {
        //             setBadge(item?.toLowerCase().split("badge:")[1].trim())
        //         }
        //     })
        // } else if (is25off) {
        //     setBadge("25% off")
        // } else if (isSaleOnSale) {
        //     tags1?.forEach((item) => {
        //         if (item.toLowerCase().includes("badge") && item.toLowerCase().includes("sale on sale")) {
        //             setBadge(item?.toLowerCase().split("badge:")[1].trim())
        //         }
        //     })
        // } else if (isNewToSale) {
        //     tags1?.forEach((item) => {
        //         if (item.toLowerCase().includes("badge") && item.toLowerCase().trim().includes("new to sale")) {
        //             setBadge("new to sale")
        //         }
        //     })
        // } else if (isNewArrival) {
        //     tags1?.forEach((item) => {
        //         if (item.toLowerCase().includes("badge") && item.toLowerCase().includes("new")) {
        //             setBadge("new arrivals")
        //         }
        //     })
        // }
        // else if (isLimited20) {
        //     tags1?.forEach((item) => {
        //         if (item.toLowerCase().includes("badge") && item.toLowerCase().includes("limited 20% off")) {
        //             setBadge("limited 20% off")
        //         }
        //     })
        // } else if (isLimited30) {
        //     tags1?.forEach((item) => {
        //         if (item.toLowerCase().includes("badge") && item.toLowerCase().includes("limited 30% off")) {
        //             setBadge("limited 30% off")
        //         }
        //     })
        // } else if (isLimited40) {
        //     tags1?.forEach((item) => {
        //         if (item.toLowerCase().includes("badge") && item.toLowerCase().includes("limited 40% off")) {
        //             setBadge("limited 40% off")
        //         }
        //     })
        // }
        // else if (isLimited50) {
        //     tags1?.forEach((item) => {
        //         if (item.toLowerCase().includes("badge") && item.toLowerCase().includes("limited 50% off")) {
        //             setBadge("limited 50% off")
        //         }
        //     })
        // } else if (isLimited60) {
        //     tags1?.forEach((item) => {
        //         if (item.toLowerCase().includes("badge") && item.toLowerCase().includes("limited 60% off")) {
        //             setBadge("limited 60% off")
        //         }
        //     })
        // } else if (isLimitedTime) {
        //     tags1?.forEach((item) => {
        //         if (item.toLowerCase().includes("badge") && item.toLowerCase().includes("limited time off")) {
        //             setBadge("limited time offer")
        //         }
        //     })
        // } 
        else {
            setBadge("")
        }
    }, [product])

    return (
        <>
            {badge != "" && <div class="ns-badge">
                <span class="ns-badge-name">{badge}</span>
            </div>}
        </>
    )
}